import React from 'react';
import { baseURL } from 'config/api.js';
import { useState, useEffect } from 'react';
import './employeesNew.css';
import { AuthContext } from '../../context/AuthContext.jsx';
import { useContext } from 'react';
import Layout from 'components/global/Layout';
import Loader from 'components/global/Loader';
import Picture from '../../assets/Group 9998.png';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';

export const EmployeesNew = () => {
  const [message, setMessage] = useState(null);
  const [companies, setCompanies] = useState(null);
  const [departments, setDepartments] = useState(null);
  const [roles, setRoles] = useState(null);
  const [workingShifts, setWorkingShifts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDepartmentsLoading, setIsDepartmentsLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(Picture);
  const { userData } = useContext(AuthContext);

  async function fetchData() {
    let url = baseURL + "/companies/";
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };
    const response = await fetch(url, {
      method: "GET",
      headers: headers
    });
    const jsonData = await response.json();
    if (!response.ok) {
      toast.error(jsonData.data.message);
      setMessage(jsonData.data.message);
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }
    const companies = jsonData.data.docs;

    if (companies.length === 0) {
      toast.error("Please create a company and its departments first.");
      setMessage("Please create a company and its departments first.");
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }

    let getDepartmentsURL = baseURL + "/departments/of-company/" + companies[0]._id;
    const getDepartmentsResponse = await fetch(getDepartmentsURL, {
      method: "GET",
      headers: headers
    });
    const getDepartmentsJSONData = await getDepartmentsResponse.json();
    if (!getDepartmentsResponse.ok) {
      toast.error(getDepartmentsJSONData.data.message);
      setMessage(getDepartmentsJSONData.data.message);
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }
    const departments = getDepartmentsJSONData.data.docs;

    let getRolesURL = baseURL + "/roles/";
    const getRolesResponse = await fetch(getRolesURL, {
      method: "GET",
      headers: headers
    });
    const getRolesJSONData = await getRolesResponse.json();
    if (!getRolesResponse.ok) {
      toast.error(getRolesJSONData.data.message);
      setMessage(getRolesJSONData.data.message);
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }
    const roles = getRolesJSONData.data.docs;

    let getWorkingShiftsURL = baseURL + "/workinghours";
    const getWorkingShiftsResponse = await fetch(getWorkingShiftsURL, {
      method: "GET",
      headers: headers
    });
    const getWorkingShiftsJSONData = await getWorkingShiftsResponse.json();
    if (!getWorkingShiftsResponse.ok) {
      toast.error(getWorkingShiftsJSONData.data.message);
      setMessage(getWorkingShiftsJSONData.data.message);
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }
    const workingShifts = getWorkingShiftsJSONData.data.docs;

    setCompanies(companies);
    setDepartments(departments);
    setRoles(roles);
    setWorkingShifts(workingShifts);
    setIsLoading(false);
  }

  async function sendAPIRequest(payload) {
    console.log("Inside sendAPIRequest");
    let url = baseURL + "/employees/create";
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
    });
    const jsonData = await response.json();
    if (jsonData.success) {
      toast.success(jsonData.data.message);
      setMessage(jsonData.data.message);
      return Promise.resolve("success");
    }
    else {
      toast.error(jsonData.data.message);
      setMessage(jsonData.data.message);
      return Promise.reject("failure");
    }
  }

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const convertManyFilesToBase64 = (fileHandles, numberOfFiles) => {
    let promises = [];
    for (let i = 0; i < numberOfFiles; i++) {
      let fileHandle = fileHandles[i][1];
      promises.push(convertToBase64(fileHandle));
    }
    return Promise.all(promises);
  }

  const handleCompanyChange = async () => {
    setIsDepartmentsLoading(true);
    let companyObjectId = document.getElementsByName("company")[0].value;
    let url = baseURL + "/departments/of-company/" + companyObjectId;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };
    const response = await fetch(url, {
      method: "GET",
      headers: headers
    });
    const jsonData = await response.json();
    const departments = jsonData.data.docs;
    setDepartments(departments);
    setIsDepartmentsLoading(false);
  }

  const handleProfilePictureChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImageSrc(imageUrl);
    }
  };

  async function handleCreateEmployeeForm(event) {
    event.preventDefault();
    let errors = [];
    let createEmployeeForm = event?.target;

    setIsSubmitting(true);
    setIsDisabled(true);

    let payload = {}; //empty object
    let full_name = createEmployeeForm.elements.namedItem("full_name")?.value;
    let father_name = createEmployeeForm.elements.namedItem("father_name")?.value;
    let email = createEmployeeForm.elements.namedItem("email")?.value;
    let employment_status = createEmployeeForm.elements.namedItem("employment_status")?.value;
    let gender = createEmployeeForm.elements.namedItem("gender")?.value;
    let birthdate = createEmployeeForm.elements.namedItem("birthdate")?.value;
    let joining_date = createEmployeeForm.elements.namedItem("joining_date")?.value;
    let cnic_number = createEmployeeForm.elements.namedItem("cnic_number")?.value;
    let mobile_phone_number = createEmployeeForm.elements.namedItem("mobile_phone_number")?.value;
    let referred_by = createEmployeeForm.elements.namedItem("referred_by")?.value;
    let permanent_address = createEmployeeForm.elements.namedItem("permanent_address")?.value;
    let mailing_address = createEmployeeForm.elements.namedItem("mailing_address")?.value;
    let salary = createEmployeeForm.elements.namedItem("salary")?.value;
    let company = createEmployeeForm.elements.namedItem("company")?.value;
    let department = createEmployeeForm.elements.namedItem("department")?.value;
    let role_slug = createEmployeeForm.elements.namedItem("role_slug")?.value;
    let workingShift = createEmployeeForm.elements.namedItem("workingShift").value;

    let ssc_board = createEmployeeForm.elements.namedItem("ssc_board")?.value;
    let ssc_passing_year = createEmployeeForm.elements.namedItem("ssc_passing_year")?.value;
    let ssc_obtained_marks = createEmployeeForm.elements.namedItem("ssc_obtained_marks")?.value;
    let ssc_total_marks = createEmployeeForm.elements.namedItem("ssc_total_marks")?.value;

    let hssc_board = createEmployeeForm.elements.namedItem("hssc_board")?.value;
    let hssc_passing_year = createEmployeeForm.elements.namedItem("hssc_passing_year")?.value;
    let hssc_obtained_marks = createEmployeeForm.elements.namedItem("hssc_obtained_marks")?.value;
    let hssc_total_marks = createEmployeeForm.elements.namedItem("hssc_total_marks")?.value;

    let bachelors_univ = createEmployeeForm.elements.namedItem("bachelors_univ")?.value;
    let bachelors_degree_title = createEmployeeForm.elements.namedItem("bachelors_degree_title")?.value;
    let bachelors_passing_year = createEmployeeForm.elements.namedItem("bachelors_passing_year")?.value;
    let bachelors_obtained_marks = createEmployeeForm.elements.namedItem("bachelors_obtained_marks")?.value;
    let bachelors_total_marks = createEmployeeForm.elements.namedItem("bachelors_total_marks")?.value;

    let masters_univ = createEmployeeForm.elements.namedItem("masters_univ")?.value;
    let masters_degree_title = createEmployeeForm.elements.namedItem("masters_degree_title")?.value;
    let masters_passing_year = createEmployeeForm.elements.namedItem("masters_passing_year")?.value;
    let masters_obtained_marks = createEmployeeForm.elements.namedItem("masters_obtained_marks")?.value;
    let masters_total_marks = createEmployeeForm.elements.namedItem("masters_total_marks")?.value;

    let ssc = {
      years_of_education: 10,
      degree_title: "Secondary School Certificate",
      awarding_org: ssc_board,
      passing_year: ssc_passing_year,
      obtained_marks: ssc_obtained_marks,
      total_marks: ssc_total_marks
    };
    let hssc = {
      years_of_education: 12,
      degree_title: "Higher Secondary School Certificate",
      awarding_org: hssc_board,
      passing_year: hssc_passing_year,
      obtained_marks: hssc_obtained_marks,
      total_marks: hssc_total_marks
    };
    let bachelors = {
      years_of_education: 16,
      degree_title: bachelors_degree_title,
      awarding_org: bachelors_univ,
      passing_year: bachelors_passing_year,
      obtained_marks: bachelors_obtained_marks,
      total_marks: bachelors_total_marks
    };
    let masters = {
      years_of_education: 18,
      degree_title: masters_degree_title,
      awarding_org: masters_univ,
      passing_year: masters_passing_year,
      obtained_marks: masters_obtained_marks,
      total_marks: masters_total_marks
    };

    let degrees = [];
    if (ssc.awarding_org.length > 0) {
      degrees.push(ssc);
    }
    if (hssc.awarding_org.length > 0) {
      degrees.push(hssc);
    }
    if (bachelors.awarding_org.length > 0) {
      degrees.push(bachelors);
    }
    if (masters.awarding_org.length > 0) {
      degrees.push(masters);
    }

    let pictures = [];
    let picture = createEmployeeForm.elements.namedItem("picture").files[0];
    let cnic_front = createEmployeeForm.elements.namedItem("cnic_front").files[0];
    let cnic_back = createEmployeeForm.elements.namedItem("cnic_back").files[0];
    let resume = createEmployeeForm.elements.namedItem("resume").files[0];
    let police_certificate = createEmployeeForm.elements.namedItem("police_certificate").files[0];

    if (picture) { //undefined if no file was selected
      if (((picture.size / 1024) / 1024) > 3) { //if greater than 3 megabytes
        errors.push("Profile picture size should be less than 3 MB");
      }
      else {
        pictures.push(['picture', picture]);
      }
    }
    if (cnic_front) {
      if (((cnic_front.size / 1024) / 1024) > 3) {
        errors.push("CNIC Front size should be less than 3 MB");
      }
      else {
        pictures.push(['cnic_front', cnic_front]);
      }
    }
    if (cnic_back) {
      if (((cnic_back.size / 1024) / 1024) > 3) {
        errors.push("CNIC Back size should be less than 3 MB");
      }
      else {
        pictures.push(['cnic_back', cnic_back]);
      }
    }
    if (resume) {
      if (((resume.size / 1024) / 1024) > 3) {
        errors.push("Resume size should be less than 3 MB");
      }
      else {
        pictures.push(['resume', resume]);
      }
    }
    if (police_certificate) {
      if (((police_certificate.size / 1024) / 1024) > 3) {
        errors.push("Police certificate size should be less than 3 MB");
      }
      else {
        pictures.push(['police_certificate', police_certificate]);
      }
    }

    try {
      let numberOfFiles = pictures.length;
      if (numberOfFiles > 0) {
        let results = await convertManyFilesToBase64(pictures, numberOfFiles);
        for (let i = 0; i < numberOfFiles; i++) {
          payload[pictures[i][0]] = results[i];
        }
      }
    }
    catch (error) {
      console.log(error);
      return;
    }

    payload.full_name = full_name;
    payload.father_name = father_name;
    payload.email = email;
    payload.employment_status = employment_status;
    payload.gender = gender;
    payload.birthdate = birthdate;
    payload.joining_date = joining_date;
    payload.cnic_number = cnic_number;
    payload.mobile_phone_number = mobile_phone_number;
    payload.referred_by = referred_by;
    payload.permanent_address = permanent_address;
    payload.mailing_address = mailing_address;
    payload.salary = salary;
    payload.company = company;
    payload.department = department;
    payload.role_slug = role_slug;
    payload.workingShift = workingShift;
    payload.degrees = degrees;

    let roleID = roles.find((role) => role.slug === role_slug)._id;
    payload.roleID = roleID;

    if (errors.length > 0) {
      let errorMessage = errors.join(', ');
      toast.error(errorMessage);
      setMessage(errorMessage);
      setIsSubmitting(false);
      setIsDisabled(false);
    }
    else {
      try {
        await sendAPIRequest(payload);
        setIsSubmitting(false);
      }
      catch (error) {
        setIsSubmitting(false);
        setIsDisabled(false);
      }
    }

  }

  useEffect(() => {
    fetchData().catch(e => {
      setIsLoading(false);
      setMessage("An error occurred while communicating with the server.");
      toast.error("An error occurred while communicating with the server.");
    });
    // eslint-disable-next-line
  }, []);

  if (isLoading || (!isLoading && isLoadingError)) {
    return (
      <Layout>
        <div className='space-y-5'>
          <div className='flex flex-row justify-between items-center px-3'>
            <h2 className='text-2xl text-primary font-bold'>Employee Name Details</h2>
          </div>
          <div className='flex flex-row justify-start'>
            <div>
              {message && message}
            </div>
          </div>
          {isLoading && <Loader />}
        </div>
      </Layout>
    );
  }

  let companiesList = [];
  let departmentsList = [];
  let rolesList = [];

  if (companies && companies.length !== 0) {
    companiesList = companies.map((company, index) => {
      return (
        <option key={company._id} value={company._id}>{company.name}</option>
      );
    });
  }

  if (departments && departments.length !== 0) {
    departmentsList = departments.map((department, index) => {
      return (
        <option key={department._id} value={department._id}>{department.department_name}</option>
      );
    });
  }

  if (roles && roles.length !== 0) {
    rolesList = roles.map((role, index) => {
      return (
        <option key={role._id} value={role.slug}>{role.name}</option>
      );
    });
  }

  console.log("Before EmployeesNew() rendering");

  return (
    <Layout>
      <div className='w-full space-y-5 '>
        <div className='flex flex-row justify-between items-center px-3 '>
          <h2 className='text-2xl text-primary font-bold'>Employee Name Details</h2>
        </div>
        <div className='flex flex-row justify-start'>
          <div>
            {message && message}
          </div>
        </div>
        <div className='flex flex-col px-4 border border-[#2F80ED] rounded-lg'>
          <form id="createEmployeeForm" onSubmit={handleCreateEmployeeForm}>

            <div className='flex flex-col md:flex-row my-3'>

              <div
                className='flex flex-col justify-center w-full md:w-2/5'
                onClick={(e) => {
                  document.getElementById('profilePicture').click();
                }}
              >
                {
                  imageSrc ? (
                    <img
                      src={imageSrc}
                      alt='img'
                      id="profile-pic"
                      className='w-[209px] h-[209px] rounded-full mx-auto overflow-hidden cursor-pointer'
                    />
                  ) : (
                    <img
                      src={Picture}
                      alt='img'
                      id="profile-pic"
                      className='w-[209px] h-[209px] rounded-full mx-auto overflow-hidden cursor-pointer'
                    />
                  )
                }
                <label
                  className='text-center text-[#2F80ED] cursor-pointer'
                  htmlFor='input-file'
                >
                  Upload Photo of Employee
                </label>
                <input
                  type="file"
                  name="picture"
                  accept='image/jpeg,image/png,image/jpg'
                  className='hidden'
                  id='profilePicture'
                  onChange={handleProfilePictureChange}
                />
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-3/5'>

                <label className='text-base font-normal pt-0 md:pt-12 text-left'>
                  Full Name <span className='required'>*</span>
                </label>
                <input 
                  type="text" 
                  name="full_name" 
                  placeholder='Employee Name' 
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />

                <label className='text-base font-normal text-left'>
                  Father's Name <span className='required'>*</span>
                </label>
                <input 
                  type="text" 
                  name="father_name" 
                  placeholder='Employee Father Name' 
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />

              </div>

            </div>

            <div className='flex flex-col md:flex-row space-y-3 md:space-y-0 my-3'>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Gender <span className='required'>*</span>
                </label>
                <select 
                  name="gender" 
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm'
                >
                  <option value="0">Male</option>
                  <option value="1">Female</option>
                  <option value="2">Others</option>
                </select>
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Date of Birth <span className='required'>*</span>
                </label>
                <input 
                  type="date" 
                  name="birthdate" 
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm ' 
                />
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Date of Enrollment <span className='required'>*</span>
                </label>
                <input 
                  type="date" 
                  name="joining_date" 
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm ' 
                />
              </div>

            </div>

            <div className='flex flex-col md:flex-row space-y-3 md:space-y-0  my-3'>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  CNIC <span className='required'>*</span>
                </label>
                <input 
                  type="text" 
                  name="cnic_number" 
                  placeholder='0000000000000' 
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Mobile Number <span className='required'>*</span>
                </label>
                <input 
                  type="text" 
                  name="mobile_phone_number" 
                  placeholder='Employe Number' 
                  className='border border-[#8E8EA1]  w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Reference
                </label>
                <input 
                  type="text" 
                  name="referred_by" 
                  placeholder='Name of Reference' 
                  className='border border-[#8E8EA1]  w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

            </div>

            <div className='flex flex-col md:flex-row space-y-3 md:space-y-0 my-3'>

              <div className='flex flex-col space-y-3 w-full md:w-1/3 '>
                <label className='text-base font-normal text-left'>
                  Email <span className='required'>*</span>
                </label>
                <input 
                  type="text" 
                  name="email" 
                  placeholder='Email'
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Permanent Address <span className='required'>*</span>
                </label>
                <input 
                  type="text" 
                  name="permanent_address" 
                  placeholder='Permanent Address' 
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Mailing Address
                </label>
                <input 
                  type="text" 
                  name="mailing_address" 
                  placeholder='Mailing Address' 
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

            </div>

            <div className='flex flex-col md:flex-row space-y-3 md:space-y-0 my-3'>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Pay Decided <span className='required'>*</span>
                </label>
                <input 
                  type="number" 
                  min={0}
                  name="salary" 
                  placeholder='' 
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Company Name <span className='required'>*</span>
                </label>
                <select 
                  name="company" 
                  onChange={handleCompanyChange} 
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm'
                >
                  {companiesList}
                </select>
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className='text-base font-normal text-left'>
                  Employment Status <span className='required'>*</span>
                </label>
                <select 
                  name="employment_status" 
                  className='border border-[#8E8EA1] py-2 w-full md:w-11/12 rounded-[40px] px-3 outline-none text-sm'
                >
                  <option value="0">Active</option>
                  <option value="1">On Leave</option>
                  <option value="2">Terminated</option>
                </select>
              </div>

            </div>

            <div className='flex flex-col justify-start md:flex-row md:justify-center space-y-3 md:space-y-0 my-3'>

              <div className='flex flex-col space-y-3 w-full md:w-2/4'>
                <label className='text-base font-normal text-left'>
                  Department <span className='required'>*</span>
                </label>
                {
                  isDepartmentsLoading ? <div className='text-center md:pt-2'><ClipLoader size={17} color="#000" /></div>
                    : (
                      <select
                        name="department"
                        className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm'
                      >
                        {departmentsList}
                      </select>
                    )
                }
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-2/4'>
                <label className='text-base font-normal text-left'>
                  Designation <span className='required'>*</span>
                </label>
                <select
                  name="role_slug"
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm'
                >
                  {rolesList}
                </select>
              </div>

              <div className='flex flex-col gap-y-3 w-full md:w-2/4'>
                <label className='text-base font-normal text-left'>
                  Working Shift <span className='required'>*</span>
                </label>
                <select
                  name="workingShift"
                  className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm'
                >
                  {
                    workingShifts && workingShifts.length > 0 && workingShifts.map((shift) => {
                      return (
                        <option key={shift._id} value={shift._id}>{shift.shiftTitle}</option>
                      );
                    })
                  }
                </select>
              </div>

            </div>

            <div className=' space-y-3 w-full my-3'>
              <h2 className='text-[#22242C] text-[22px]'>Add Educational Details</h2>
            </div>

            <div className=' space-y-3 w-full my-3'>
              <label className='text-[#22242C] text-[20px]'>SSC:</label>
            </div>

            <div className='flex flex-col md:flex-row space-y-3 md:space-y-0 space-x-0 md:space-x-3  my-3 w-full'>

              <div className='w-full md:w-1/4'>
                <input 
                  type="text" 
                  name="ssc_board" 
                  placeholder='Matric Board'
                  className='border border-[#8E8EA1] w-full py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-1/4'>
                <input 
                  type="text" 
                  name="ssc_passing_year" 
                  placeholder='Matric Passing Year'
                  className='border border-[#8E8EA1] w-full py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-1/4' >
                <input 
                  type="text" 
                  name="ssc_obtained_marks" 
                  placeholder='Matric Obtained Marks'
                  className='border border-[#8E8EA1] w-full py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-1/4' >
                <input 
                  type="text" 
                  name="ssc_total_marks" 
                  placeholder='Matric Total Marks'
                  className='border border-[#8E8EA1] w-full py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

            </div>

            <div className='space-y-3 w-full my-3'>
              <label className='text-[#22242C] text-[20px]'>HSSC:</label>
            </div>

            <div className='flex flex-col md:flex-row space-y-3 md:space-y-0 space-x-0 md:space-x-3  my-3 w-full '>

              <div className='w-full md:w-1/4 '>
                <input 
                  type="text" 
                  name="hssc_board" 
                  placeholder='Inter Board'
                  className='border border-[#8E8EA1] w-full py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-1/4 '>
                <input 
                  type="text" 
                  name="hssc_passing_year" 
                  placeholder='Inter Passing Year'
                  className='border border-[#8E8EA1] w-full py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-1/4'>
                <input 
                  type="text" 
                  name="hssc_obtained_marks" 
                  placeholder='Inter Obtained Marks'
                  className='border border-[#8E8EA1] w-full py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-1/4 ' >
                <input 
                  type="text" 
                  name="hssc_total_marks" 
                  placeholder='Inter Total Marks'
                  className='border border-[#8E8EA1] w-full py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

            </div>

            <div className=' space-y-3 w-full my-3'>
              <label className='text-[#22242C] text-[20px]'>Bachelors:</label>
            </div>

            <div className='flex flex-col md:flex-wrap md:flex-row  space-y-3 md:space-y-0  my-3'>

              <div className='w-full md:w-2/6'>
                <input 
                  type="text" 
                  name="bachelors_univ" 
                  placeholder='University'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-2/6'>
                <input 
                  type="text" 
                  name="bachelors_degree_title" 
                  placeholder='Bachelors Degree Title'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-2/6' >
                <input 
                  type="text" 
                  name="bachelors_passing_year" 
                  placeholder='Bachelors Passing Year'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-2/6 py-0 md:py-3 '  >
                <input 
                  type="text" 
                  name="bachelors_obtained_marks" 
                  placeholder='Bachelors Obtained Marks or CGPA'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-2/6  py-0 md:py-3  ' >
                <input 
                  type="text" 
                  name="bachelors_total_marks" 
                  placeholder='Bachelors Total Marks or CGPA'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

            </div>

            <div className=' space-y-3 w-full  my-3'>
              <label className='text-[#22242C] text-[20px]'>Masters: </label>
            </div>

            <div className='flex flex-col md:flex-wrap md:flex-row  space-y-3 md:space-y-0  my-3'>

              <div className=' w-full md:w-2/6'>
                <input 
                  type="text" 
                  name="masters_univ" 
                  placeholder='University'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-2/6'>
                <input 
                  type="text" 
                  name="masters_degree_title" 
                  placeholder='Masters Degree Title'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-2/6'>
                <input 
                  type="text" 
                  name="masters_passing_year" 
                  placeholder='Masters Passing Year'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='w-full md:w-2/6 py-0 md:py-3'>
                <input 
                  type="text" 
                  name="masters_obtained_marks" 
                  placeholder='Masters Obtained Marks or CGPA'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm ' 
                />
              </div>

              <div className='w-full md:w-2/6 py-0 md:py-3'>
                <input 
                  type="text" 
                  name="masters_total_marks" 
                  placeholder='Masters Total Marks or CGPA'
                  className='border border-[#8E8EA1] w-full  md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

            </div>


            <div className='flex flex-col md:flex-row md:flex-wrap gap-y-3 md:space-y-0 my-3'>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>

                <label className='text-base font-normal text-left'>CNIC Front:</label>
                <input 
                  type="file" 
                  accept='image/*'
                  name="cnic_front" 
                  className='border border-[#8E8EA1] py-2 w-full md:w-11/12 rounded-[40px] px-3 outline-none text-sm' 
                />

              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>

                <label className='text-base font-normal text-left'>CNIC Back:</label>
                <input 
                  type="file" 
                  accept='image/*'
                  name="cnic_back" 
                  className='border border-[#8E8EA1] py-2 w-full md:w-11/12 rounded-[40px] px-3 outline-none text-sm' 
                />

              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>

                <label className='text-base font-normal text-left'>Resume:</label>
                <input 
                  type="file" 
                  accept='application/pdf'
                  name="resume" 
                  className='border border-[#8E8EA1] py-2 w-full md:w-11/12 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>

                <label className='text-base font-normal text-left'>Police Character Certificate:</label>
                <input 
                  type="file"
                  accept='image/*'
                  name="police_certificate" 
                  className='border border-[#8E8EA1] py-2 w-full md:w-11/12 rounded-[40px] px-3 outline-none text-sm' 
                />
              </div>
              
            </div>

            <div className='flex flex-row justify-center my-5'>
              <button
                disabled={isSubmitting || isDisabled}
                type="submit"
                id="submit"
                className='text-white bg-primary rounded-[40px] w-[299px] h-9'
              >
                {isSubmitting ? <ClipLoader size={17} color="#fff" /> : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
}
